export default __webpack_public_path__ + "static/media/arrow.dd84713a.svg";